<div class="loading-cont" [ngClass]="{ 'loading-edit-page-cont': !listingPage }" *ngIf="loading"><div class="loading-spinner"></div></div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/loader/loader.component.html